"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderBackgroundImage = exports.parseQuadrantClass = exports.parseContentMargin = exports.mapQuadrantContent = exports.hasContentPoints = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Header = _interopRequireDefault(require("../Header/Header"));
var _DataPoint = _interopRequireDefault(require("../DataPoint/DataPoint"));
var _LottieAnimation = _interopRequireDefault(require("../LottieAnimation/LottieAnimation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//Region: parse quadrant classes
const parseQuadrantClass = (quadrantPosition, backgroundColor, hasImageContent, contentProperties) => {
  const {
    hasOneBackgroundImage,
    hasFourBackgroundImages,
    hasOvelappingContent,
    hasShortDataPointContent,
    hasDataPointContent
  } = contentProperties;

  //Init base class
  let quadrantClass = "luna-2x2__content-quadrant";

  //Add background color
  quadrantClass += ` luna-2x2__content-quadrant--${backgroundColor} luna-2x2__content-quadrant--${backgroundColor}${hasOneBackgroundImage || hasFourBackgroundImages ? "--background-image" : ""}`;

  //Cases:
  //1 background image
  if (hasOneBackgroundImage) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--one-background-image`;
    //4 background images
  } else if (hasFourBackgroundImages) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--four-background-images`;
    //0 background images, doesn't have image content, content doesn't overlap
  } else if (!hasImageContent && !hasOvelappingContent) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--no-image--no-overlap`;
    //0 background images, has image content, content doesn't overlap
  } else if (hasImageContent && !hasOvelappingContent) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--has-image--no-overlap`;
    //0 background images, doesn't have image content, content overlaps
  } else if (!hasImageContent && hasOvelappingContent) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--no-image--has-overlap`;
    //0 background images, has image content, content overlaps
  } else {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--has-image--has-overlap`;
  }
  if (hasImageContent && hasShortDataPointContent) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--has-image--has-short-data-point`;
  } else if (!hasImageContent && hasShortDataPointContent) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--no-image--has-short-data-point`;
  }
  if (hasImageContent && !hasShortDataPointContent && hasDataPointContent) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--has-image--has-data-point`;
  } else if (!hasImageContent && !hasShortDataPointContent && hasDataPointContent) {
    quadrantClass += ` luna-2x2__content-quadrant__${quadrantPosition}--zero-background-images--no-image--has-data-point`;
  }
  return quadrantClass;
};
exports.parseQuadrantClass = parseQuadrantClass;
const parseContentMargin = (hasImageContent, hasDataPointContent) => {
  return hasImageContent ? "luna-2x2__content-quadrant--image" : `luna-2x2__content-quadrant--content ${hasDataPointContent && "luna-2x2__content-quadrant--has-data-point"}`;
};

//End Region: parse quadrant classes

//Region: map quadrant content
exports.parseContentMargin = parseContentMargin;
const mapQuadrantContent = function (content, backgroundColor) {
  let isShortDataPoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return content?.map((item, index) => {
    const theme = {
      color: backgroundColor === "white" || backgroundColor === "concrete-gray" ? "#252a2e" : "white",
      backgroundColor: "none"
    };
    let component;
    switch (item.type) {
      case "Header":
        component = /*#__PURE__*/_react.default.createElement(_Header.default
        //We are intentionally not passing eyebrow or subhead
        , {
          headline: item.headline,
          theme: theme
        });
        break;
      case "Rich Text":
        component = item.content;
        break;
      case "Image":
        component = /*#__PURE__*/_react.default.createElement("img", {
          src: item?.focalPointImage?.url,
          alt: item?.focalPointImage?.title ? item?.focalPointImage?.title : "",
          className: "luna-2x2__content-quadrant--image"
        });
        break;
      case "Data Point":
        component = /*#__PURE__*/_react.default.createElement(_DataPoint.default, {
          points: item?.points,
          theme: theme,
          variant: item?.points?.length > 1 ? "variant_1" : "variant_3"
        });
        break;
      case "Stat":
        component = /*#__PURE__*/_react.default.createElement("div", {
          className: "luna-stat-container"
        }, item?.content?.stat && /*#__PURE__*/_react.default.createElement("h2", {
          className: "luna-stat-container__stat"
        }, item?.content?.stat), item?.content?.subheader && /*#__PURE__*/_react.default.createElement("h4", {
          className: "luna-stat-container__subheader"
        }, item?.content?.subheader), item?.content?.text && /*#__PURE__*/_react.default.createElement("p", {
          className: "luna-stat-container__text"
        }, item?.content?.text));
        break;
      case "lottieAnimation":
        const lottieAnimationRatio = isShortDataPoint ? {
          width: 1,
          height: 1
        } : {
          width: 13,
          height: 8
        };
        component = /*#__PURE__*/_react.default.createElement("div", {
          className: "luna-2x2--lottie-animation"
        }, /*#__PURE__*/_react.default.createElement(_LottieAnimation.default, {
          src: item?.src,
          style: {
            ...item?.style
          },
          ratio: lottieAnimationRatio
        }));
        break;
      default:
        component = null;
    }
    return index ? /*#__PURE__*/_react.default.createElement("div", {
      key: `2x2-quadrant-content-${item.title}-${index}`,
      className: "luna-2x2__content-spacer"
    }, component) : /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: `2x2-quadrant-content-${item.title}-${index}`
    }, component);
  });
};
exports.mapQuadrantContent = mapQuadrantContent;
const renderBackgroundImage = (backgroundImage, backgroundCount) => {
  if (backgroundImage?.type === 'lottieAnimation') {
    const backgroundAnimationRatio = backgroundCount => {
      switch (backgroundCount) {
        case 1:
          return {
            width: 14,
            height: 11
          };
        case 2:
          return {};
        case 3:
          return {
            width: 14,
            height: 11
          };
        case 4:
          return {
            width: 60,
            height: 47
          };
        default:
          return null;
      }
    };
    return /*#__PURE__*/_react.default.createElement(_LottieAnimation.default, {
      src: backgroundImage?.src,
      style: backgroundImage?.style || null,
      className: `luna-2x2__background-image`,
      ratio: backgroundAnimationRatio(backgroundCount)
    });
  } else {
    return /*#__PURE__*/_react.default.createElement("img", {
      src: backgroundImage?.focalPointImage?.url
      //@K+C UX recommends not adding alt tags on textural background images
      ,
      alt: backgroundImage?.focalPointImage?.title ? backgroundImage?.focalPointImage?.title : "",
      className: `luna-2x2__background-image`
    });
  }
};

//End Region: map quadrant content
exports.renderBackgroundImage = renderBackgroundImage;
const hasContentPoints = content => {
  return content?.some(item => item?.points?.length > 0);
};
exports.hasContentPoints = hasContentPoints;